import { DATE_IN_THE_PAST_WEB } from './cookies.constants';
import { safelyGetUrlInstance } from './cookies.helpers';

/**
 * Deletes a cookie using the CookieStore API.
 * Fallback to overriding the cookie on the document if CookieStore is not available.
 */
export const deleteCookie = async (name: string, url: string) => {
  const urlInstance = safelyGetUrlInstance(url);

  if (!urlInstance) return;

  const currentDomain = window.location.hostname;
  const cookieDomain = urlInstance.hostname;
  const isDeletingOnSameDomain = currentDomain === cookieDomain;

  if ('cookieStore' in window && isDeletingOnSameDomain) {
    const { cookieStore } = window as { cookieStore: CookieStore };

    return cookieStore.delete({ name, domain: cookieDomain });
  }

  // eslint-disable-next-line unicorn/no-document-cookie
  document.cookie = `${name}=; expires=${DATE_IN_THE_PAST_WEB}; domain=${cookieDomain}; path=/;`;
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CookieStore = {
  delete(options?: CookieDeleteOptions): Promise<void>;
};

type CookieDeleteOptions = {
  name: string;
  domain?: string;
};
